const allowedKeysRegex = /^\d{1}$/

export const zipMask = [
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
]
